module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_c('center', [(_vm.productSalesList == '') ? _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [(_vm.search != '') ? _c('a', {
    staticClass: "searchTypeClear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearSearch.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons searchTypeClearText"
  }, [_vm._v("close")])]) : _vm._e(), _vm._v(" "), (_vm.productSalesList != '' && _vm.search != '') ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.productSalesList != '' && _vm.search == '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1)]), _vm._v(" "), (_vm.productSalesList != null && _vm.productSalesList != '') ? _c('v-data-table', {
    staticClass: "elevation-1 mainTable",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "headers": _vm.headers,
      "id": "hello",
      "search": _vm.search,
      "items": _vm.productSalesList,
      "rows-per-page-items": [20, 40, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return (props.item.display == true) ? [_c('td', {
          attrs: {
            "width": "40%"
          }
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.gross)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.discount)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.nett)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "15%"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              props.expanded = !props.expanded
            }
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewProducts(props.item.name)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("device_hub")])])])] : undefined
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-data-table', {
          staticClass: "elevation-1 subTable2",
          staticStyle: {
            "font-size": "10px"
          },
          attrs: {
            "headers": _vm.productHeaders,
            "search": _vm.search,
            "items": props.item.children,
            "hide-actions": "",
            "rows-per-page-items": [20000]
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return (props.item.display == true) ? [_c('td', {
                attrs: {
                  "width": "23%"
                },
                domProps: {
                  "innerHTML": _vm._s(_vm.fncFilterName(props.item.name))
                }
              }, [_vm._v(_vm._s(_vm.fncFilterName(props.item.name)))]), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "11%"
                }
              }, [_vm._v(_vm._s(props.item.uom))]), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "11%"
                }
              }, [_vm._v(_vm._s(_vm.fncAveragePrice(props.item.gross, props.item.quantity)))]), _vm._v(" "), _c('td', {
                staticClass: "text-xs-right",
                attrs: {
                  "width": "11%"
                }
              }, [_vm._v(_vm._s(_vm.fncQuant(props.item.quantity)))]), _vm._v(" "), _c('td', {
                staticClass: "text-xs-right",
                attrs: {
                  "width": "11%"
                }
              }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.gross)))]), _vm._v(" "), _c('td', {
                staticClass: "text-xs-right",
                attrs: {
                  "width": "11%"
                }
              }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.discount)))]), _vm._v(" "), _c('td', {
                staticClass: "text-xs-right",
                attrs: {
                  "width": "11%"
                }
              }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.nett)))]), _vm._v(" "), _c('td', {
                staticClass: "text-xs-right",
                attrs: {
                  "width": "11%"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    props.expanded = !props.expanded
                  }
                }
              }, [_c('a', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncViewQuotes(props.item.products, props.item.name)
                  }
                }
              }, [_c('i', {
                staticClass: "material-icons"
              }, [_vm._v("device_hub")])])])] : undefined
            }
          }, {
            key: "expand",
            fn: function(props) {
              return [_c('v-data-table', {
                staticClass: "elevation-1 subTable3",
                staticStyle: {
                  "font-size": "10px"
                },
                attrs: {
                  "headers": _vm.quoteHeaders,
                  "search": _vm.search,
                  "items": _vm.dateList,
                  "hide-actions": "",
                  "rows-per-page-items": [20000]
                },
                scopedSlots: _vm._u([{
                  key: "items",
                  fn: function(props) {
                    return [_c('td', {
                      attrs: {
                        "width": "10%"
                      }
                    }, [_vm._v(_vm._s(props.item.date))]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "9%"
                      }
                    }, [_vm._v(_vm._s(props.item.quote_no))]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "9%"
                      }
                    }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "9%"
                      }
                    }, [_vm._v(_vm._s(props.item.tender_status))]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "9%"
                      }
                    }, [_vm._v(_vm._s(props.item.originator_name))]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "9%"
                      }
                    }, [_vm._v(_vm._s(props.item.customer_name))]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "9%"
                      }
                    }, [_vm._v(_vm._s(props.item.quantity))]), _vm._v(" "), _c('td', {
                      staticClass: "text-xs-right",
                      attrs: {
                        "width": "9%"
                      }
                    }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.gross_total)))]), _vm._v(" "), _c('td', {
                      staticClass: "text-xs-right",
                      attrs: {
                        "width": "9%"
                      }
                    }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.discount_total)))]), _vm._v(" "), _c('td', {
                      staticClass: "text-xs-right",
                      attrs: {
                        "width": "9%"
                      }
                    }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.nett_total)))]), _vm._v(" "), _c('td', {
                      staticClass: "text-xs-right",
                      attrs: {
                        "width": "9%"
                      }
                    }, [_c('a', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncViewQuote(props.item)
                        }
                      }
                    }, [_c('i', {
                      staticClass: "material-icons"
                    }, [_vm._v("list_alt")])])])]
                  }
                }], null, true)
              })]
            }
          }], null, true)
        })]
      }
    }], null, true)
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}